/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrMedicineTypename = "PhrMedicine" as const;

/**
 *
 * @export
 * @interface PhrMedicine
 */
export interface PhrMedicine {
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  classificationId?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  dispenseUnit?: string;
  /**
   *
   * @type {number}
   * @memberof PhrMedicine
   */
  groupId?: number;
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  quantity?: string;
  /**
   *
   * @type {number}
   * @memberof PhrMedicine
   */
  times?: number;
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  unit?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicine
   */
  yakkaCode?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMedicine
   */
  readonly __typename?: string;
}

export function PhrMedicineFromJSON(json: any): PhrMedicine {
  return PhrMedicineFromJSONTyped(json, false);
}

export function PhrMedicineFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMedicine {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMedicineTypename,

    classificationId: !exists(json, "classification_id") ? undefined : json["classification_id"],
    code: !exists(json, "code") ? undefined : json["code"],
    dispenseUnit: !exists(json, "dispense_unit") ? undefined : json["dispense_unit"],
    groupId: !exists(json, "group_id") ? undefined : json["group_id"],
    name: !exists(json, "name") ? undefined : json["name"],
    quantity: !exists(json, "quantity") ? undefined : json["quantity"],
    times: !exists(json, "times") ? undefined : json["times"],
    unit: !exists(json, "unit") ? undefined : json["unit"],
    yakkaCode: !exists(json, "yakka_code") ? undefined : json["yakka_code"],
  };
}

export function PhrMedicineToJSON(object?: PhrMedicine | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    classification_id: value.classificationId,
    code: value.code,
    dispense_unit: value.dispenseUnit,
    group_id: value.groupId,
    name: value.name,
    quantity: value.quantity,
    times: value.times,
    unit: value.unit,
    yakka_code: value.yakkaCode,
  };
}
